import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { InvestorAuthProvider } from "./contexts/InvestorAuthContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Founders } from "./components/Founders";
import { Services } from "./components/Services";
import { Projects } from "./components/Projects";
import { News } from "./components/News";
import { Career } from "./components/Career";
import { JoinAgent } from "./components/JoinAgent";
import { LandConverter } from "./components/LandConverter";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { AIChat } from "./components/AIChat";
import { AppointmentModal } from "./components/AppointmentModal";
import { FavoritesFab } from "./components/FavoritesFab";
import { FeaturedCarousel } from "./components/FeaturedCarousel";
import { AnnouncementPopup } from "./components/AnnouncementPopup";
import { GlobalRevealObserver } from "./components/GlobalRevealObserver";
import { DiwaliFestive } from "./components/DiwaliFestive";
const AdminLogin = React.lazy(() => import("./components/AdminLogin").then((m) => ({ default: m.AdminLogin })));
const AdminLayout = React.lazy(() => import("./components/admin/AdminLayout").then((m) => ({ default: m.AdminLayout })));
const AdminDashboard = React.lazy(() => import("./components/admin/AdminDashboard").then((m) => ({ default: m.AdminDashboard })));
const AdminProperties = React.lazy(() => import("./components/admin/AdminProperties").then((m) => ({ default: m.AdminProperties })));
const AdminServices = React.lazy(() => import("./components/admin/AdminServices").then((m) => ({ default: m.AdminServices })));
const AdminTestimonials = React.lazy(() => import("./components/admin/AdminTestimonials").then((m) => ({ default: m.AdminTestimonials })));
const AdminInquiries = React.lazy(() => import("./components/admin/AdminInquiries").then((m) => ({ default: m.AdminInquiries })));
const AdminNews = React.lazy(() => import("./components/admin/AdminNews").then((m) => ({ default: m.AdminNews })));
const AdminApplications = React.lazy(() => import("./components/admin/AdminApplications").then((m) => ({ default: m.AdminApplications })));
const AdminJobApplications = React.lazy(() => import("./components/admin/AdminJobApplications").then((m) => ({ default: m.AdminJobApplications })));
const AdminAgentApplications = React.lazy(() => import("./components/admin/AdminAgentApplications").then((m) => ({ default: m.AdminAgentApplications })));
const AdminSurveyorVisits = React.lazy(() => import("./components/admin/AdminSurveyorVisits").then((m) => ({ default: m.AdminSurveyorVisits })));
const AdminAppointments = React.lazy(() => import("./components/admin/AdminAppointments").then((m) => ({ default: m.AdminAppointments })));
const AdminChatSessions = React.lazy(() => import("./components/admin/AdminChatSessions").then((m) => ({ default: m.AdminChatSessions })));
const AdminPropertySubmissions = React.lazy(() => import("./components/admin/AdminPropertySubmissions").then((m) => ({ default: m.AdminPropertySubmissions })));
const AdminBlueprints = React.lazy(() => import("./components/admin/AdminBlueprints").then((m) => ({ default: m.AdminBlueprints })));
const AdminArchitectOrders = React.lazy(() => import("./components/admin/AdminArchitectOrders").then((m) => ({ default: m.AdminArchitectOrders })));
const AdminLandFillEstimates = React.lazy(() => import("./components/admin/AdminLandFillEstimates").then((m) => ({ default: m.AdminLandFillEstimates })));
const AdminStateRates = React.lazy(() => import("./components/admin/AdminStateRates").then((m) => ({ default: m.AdminStateRates })));
const AdminLandInvestorLeads = React.lazy(() => import("./components/admin/AdminLandInvestorLeads").then((m) => ({ default: m.AdminLandInvestorLeads })));
const AdminFractionalInvestors = React.lazy(() => import("./components/admin/AdminFractionalInvestors").then((m) => ({ default: m.AdminFractionalInvestors })));
const AdminPanelApplications = React.lazy(() => import("./components/admin/AdminPanelApplications").then((m) => ({ default: m.AdminPanelApplications })));
const AdminAnalytics = React.lazy(() => import("./components/admin/AdminAnalytics").then((m) => ({ default: m.AdminAnalytics })));
const AdminTrainingConsole = React.lazy(() => import("./components/admin/AdminTrainingConsole").then((m) => ({ default: m.AdminTrainingConsole })));
const AdminHrComms = React.lazy(() => import("./components/admin/AdminHrComms").then((m) => ({ default: m.AdminHrComms })));
const AdminCrm = React.lazy(() => import("./components/admin/AdminCrm").then((m) => ({ default: m.AdminCrm })));
const AdminParcels = React.lazy(() => import("./components/admin/AdminParcels").then((m) => ({ default: m.AdminParcels })));
const AdminOwnerLeads = React.lazy(() => import("./components/admin/AdminOwnerLeads").then((m) => ({ default: m.AdminOwnerLeads })));
import { AddPropertySection } from "./components/AddPropertySection";
import { AIArchitect } from "./components/AIArchitect";
import { ArchitectLaunchPopup } from "./components/ArchitectLaunchPopup";
const AIArchitectPage = React.lazy(() => import("./pages/AIArchitectPage"));
const LandInvestorsPage = React.lazy(() => import("./pages/LandInvestorsPage"));
const LandFillPage = React.lazy(() => import("./pages/LandFillPage"));
const ReschedulePage = React.lazy(() => import("./pages/ReschedulePage"));
const InterviewReschedulePage = React.lazy(() => import("./pages/InterviewReschedulePage"));
const TrackPage = React.lazy(() => import("./pages/TrackPage"));
const InvestPage = React.lazy(() => import("./pages/InvestPage"));
const InvestorDashboard = React.lazy(() => import("./pages/InvestorDashboard"));
const ResetPasswordPage = React.lazy(() => import("./pages/ResetPasswordPage"));
const MyAccountPage = React.lazy(() => import("./pages/MyAccountPage"));
const HrmDashboard = React.lazy(() => import("./pages/HrmDashboard"));
const CrmAppPage = React.lazy(() => import("./pages/CrmAppPage"));
const CrmDownloadPage = React.lazy(() => import("./pages/CrmDownloadPage"));
const HrmDownloadPage = React.lazy(() => import("./pages/HrmDownloadPage"));
const PartnerDownloadPage = React.lazy(() => import("./pages/PartnerDownloadPage"));
const TrainingNotePage = React.lazy(() => import("./pages/TrainingNotePage"));
const SupportPage = React.lazy(() => import("./pages/SupportPage"));
const PartnerProgressPage = React.lazy(() => import("./pages/PartnerProgressPage"));
const AdminPartnerProgress = React.lazy(() => import("./components/admin/AdminPartnerProgress").then((m) => ({ default: m.AdminPartnerProgress })));
const AdminLeaveApprovals = React.lazy(() => import("./pages/AdminLeaveApprovals"));
const AttendanceRegister = React.lazy(() => import("./pages/AttendanceRegister"));
const SiteIntelScanner = React.lazy(() => import("./pages/SiteIntelScanner"));
import { SiteIntelSection } from "./components/SiteIntelSection";
const DocumentSubmissionPage = React.lazy(() => import("./pages/DocumentSubmissionPage"));
const VastuPage = React.lazy(() => import("./pages/VastuPage"));
import { VastuSection } from "./components/VastuSection";
const VastuBookingPage = React.lazy(() => import("./pages/VastuBookingPage"));
const VastuConsultantPage = React.lazy(() => import("./pages/VastuConsultantPage"));
const VastuSharedReportPage = React.lazy(() => import("./pages/VastuSharedReportPage"));
const VideoRoomPage = React.lazy(() => import("./pages/VideoRoomPage"));
const PartnerChatPage = React.lazy(() => import("./pages/PartnerChatPage"));
const PartnerPortalPage = React.lazy(() => import("./pages/PartnerPortalPage"));
import { PartnerChatBadge } from "./components/PartnerChatBadge";
const AdminPartnerCrm = React.lazy(() => import("./components/admin/AdminPartnerCrm").then((m) => ({ default: m.AdminPartnerCrm })));
const AdminEmailPreview = React.lazy(() => import("./components/admin/AdminEmailPreview").then((m) => ({ default: m.AdminEmailPreview })));
const AdminSupport = React.lazy(() => import("./components/admin/AdminSupport").then((m) => ({ default: m.AdminSupport })));
const AdminCrmOrders = React.lazy(() => import("./components/admin/AdminCrmOrders").then((m) => ({ default: m.AdminCrmOrders })));
const AdminSalesProfit = React.lazy(() => import("./components/admin/AdminSalesProfit").then((m) => ({ default: m.AdminSalesProfit })));
const AdminExpenses = React.lazy(() => import("./components/admin/AdminExpenses").then((m) => ({ default: m.AdminExpenses })));
const AdminVastu = React.lazy(() => import("./components/admin/AdminVastu").then((m) => ({ default: m.AdminVastu })));
import { usePageviewTracker } from "./hooks/usePageviewTracker";
const Toaster = React.lazy(() => import("./components/ui/sonner").then((m) => ({ default: m.Toaster })));
import { Toaster as ShadcnToaster } from "./components/ui/toaster";
import "./App.css";

/**
 * Fires a POST /api/analytics/pageview beacon on every route change so the
 * admin can see live website-viewer stats. Rendered inside <BrowserRouter>.
 */
const PageviewTracker = () => {
  usePageviewTracker();
  return null;
};

// Main Website
const Website = () => {
  const [showGlobalAppt, setShowGlobalAppt] = React.useState(false);
  React.useEffect(() => {
    const handler = () => setShowGlobalAppt(true);
    window.addEventListener('openAppointmentModal', handler);
    return () => window.removeEventListener('openAppointmentModal', handler);
  }, []);

  // If we arrive via `/#some-section` (e.g. Header nav from /track), scroll
  // to that section once mounted. Small delay so sections have laid out.
  const { hash } = useLocation();
  React.useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    if (!id) return;
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 250);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturedCarousel />
        <About />
        <Founders />
        <Services />
        <AIArchitect />
        <Projects />
        <div className="container mx-auto px-4 lg:px-8 pb-16"><VastuSection /></div>
        <News />
        <Career />
        <JoinAgent />
        <AddPropertySection />
        <LandConverter />
        <SiteIntelSection />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <AIChat />
      <FavoritesFab />
      <AnnouncementPopup />
      <ArchitectLaunchPopup />
      <AppointmentModal
        isOpen={showGlobalAppt}
        onClose={() => setShowGlobalAppt(false)}
      />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <InvestorAuthProvider>
      <div className="App">
        <GlobalRevealObserver />
        <BrowserRouter>
          <PageviewTracker />
          <PartnerChatBadge />
          <DiwaliFestive />
          <React.Suspense fallback={<div className="min-h-screen grid place-items-center" data-testid="route-loading"><div className="h-10 w-10 rounded-full border-4 border-emerald-200 border-t-emerald-700 animate-spin" /></div>}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Website />} />
            <Route path="/ai-architect" element={<AIArchitectPage />} />
            <Route path="/land-fill" element={<LandFillPage />} />
            <Route path="/land-investors" element={<LandInvestorsPage />} />
            <Route path="/track" element={<TrackPage />} />
            <Route path="/invest" element={<InvestPage />} />
            <Route path="/investor-dashboard" element={<InvestorDashboard />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/my-account" element={<MyAccountPage />} />
            <Route path="/property/:code" element={<Website />} />
            <Route path="/documents/:token" element={<DocumentSubmissionPage />} />
            <Route path="/reschedule/:token" element={<ReschedulePage />} />
            <Route path="/interview/reschedule/:token" element={<InterviewReschedulePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/hrm" element={<HrmDashboard />} />
            <Route path="/crm-app" element={<CrmAppPage />} />
            <Route path="/crm-download" element={<CrmDownloadPage />} />
            <Route path="/hrm-download" element={<HrmDownloadPage />} />
            <Route path="/partner-download" element={<PartnerDownloadPage />} />
            <Route path="/training-note/:sid" element={<TrainingNotePage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/partner-progress" element={<PartnerProgressPage />} />
            <Route path="/careers" element={
              <div className="min-h-screen bg-slate-50 pt-4">
                <Career />
              </div>
            } />
            <Route path="/vastu" element={<VastuPage />} />
            <Route path="/vastu/booking/:code" element={<VastuBookingPage />} />
            <Route path="/vastu-consultant" element={<VastuConsultantPage />} />
            <Route path="/vastu/report/:id" element={<VastuSharedReportPage />} />
            <Route path="/room/:room" element={<VideoRoomPage />} />
            <Route path="/partner-chat" element={<PartnerChatPage />} />
            <Route path="/partner-portal" element={<PartnerPortalPage />} />
            <Route path="/site-intel" element={<SiteIntelScanner />} />
            <Route path="/site-intel/s/:slug" element={<SiteIntelScanner />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="properties" element={<AdminProperties />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="applications" element={<AdminApplications />} />
              <Route path="hr" element={<AdminJobApplications />} />
              <Route path="hr/leaves" element={<AdminLeaveApprovals />} />
              <Route path="hr/register" element={<AttendanceRegister />} />
              <Route path="hr/training" element={<AdminTrainingConsole />} />
              <Route path="hr/comms" element={<AdminHrComms />} />
              <Route path="crm" element={<AdminCrm />} />
              <Route path="parcels" element={<AdminParcels />} />
              <Route path="partner-progress" element={<AdminPartnerProgress />} />
              <Route path="owner-leads" element={<AdminOwnerLeads />} />
              <Route path="agents" element={<AdminAgentApplications />} />
              <Route path="surveyor-visits" element={<AdminSurveyorVisits />} />
              <Route path="appointments" element={<AdminAppointments />} />
              <Route path="chats" element={<AdminChatSessions />} />
              <Route path="property-submissions" element={<AdminPropertySubmissions />} />
              <Route path="blueprints" element={<AdminBlueprints />} />
              <Route path="architect-orders" element={<AdminArchitectOrders />} />
              <Route path="land-fill-estimates" element={<AdminLandFillEstimates />} />
              <Route path="land-investors" element={<AdminLandInvestorLeads />} />
              <Route path="fractional-investors" element={<AdminFractionalInvestors />} />
              <Route path="panel-applications" element={<AdminPanelApplications />} />
              <Route path="state-rates" element={<AdminStateRates />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="vastu" element={<AdminVastu />} />
              <Route path="partner-crm" element={<AdminPartnerCrm />} />
              <Route path="email-preview" element={<AdminEmailPreview />} />
              <Route path="support" element={<AdminSupport />} />
              <Route path="crm-orders" element={<AdminCrmOrders />} />
              <Route path="sales-profit" element={<AdminSalesProfit />} />
              <Route path="expenses" element={<AdminExpenses />} />
            </Route>

            {/* 404 Redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </React.Suspense>
        </BrowserRouter>
        <Toaster />
        <ShadcnToaster />
      </div>
      </InvestorAuthProvider>
    </AuthProvider>
  );
}

export default App;
